module.exports = __webpack_public_path__ + "@/assets/img/IABanner.1dc8b68f.png";